import * as axios from 'axios';

function getAll() {
	const data = {};

	const url = `/admin/traeger/all`;
	return axios
		.get(url, data)
		.then((x) => x.data)
		.then((x) => {
			if (x.status == 'error') {
				return Promise.reject(x);
			}
			return x;
		});
}

function getTraeger(uid) {
	const data = {};
	const url = `/admin/traeger/detail/${uid}`;
	return axios
		.get(url, data)
		.then((x) => x.data)
		.then((x) => {
			if (x.status == 'error') {
				return Promise.reject(x);
			}
			return x;
		});
}

function createTraeger(data) {
	const url = `/admin/traeger/create`;
	return axios
		.post(url, data)
		.then((x) => x.data)
		.then((x) => {
			if (x.status == 'error') {
				return Promise.reject(x);
			}
			return x;
		});
}

function updateTraeger(data) {
	const url = `/admin/traeger/update`;
	return axios
		.post(url, data)
		.then((x) => x.data)
		.then((x) => {
			if (x.status == 'error') {
				return Promise.reject(x);
			}
			return x;
		});
}

function getAvailableLocations() {
	const data = {};
	const url = `/admin/traeger/available-locations`;
	return axios
		.get(url, data)
		.then((x) => x.data)
		.then((x) => {
			if (x.status == 'error') {
				return Promise.reject(x);
			}
			return x;
		});
}

function assignLocation(data) {
	const url = `/admin/traeger/assign-location`;
	return axios
		.post(url, data)
		.then((x) => x.data)
		.then((x) => {
			if (x.status == 'error') {
				return Promise.reject(x);
			}
			return x;
		});
}

function unassignLocation(data) {
	const url = `/admin/traeger/unassign-location`;
	return axios
		.post(url, data)
		.then((x) => x.data)
		.then((x) => {
			if (x.status == 'error') {
				return Promise.reject(x);
			}
			return x;
		});
}

function inviteUser(data) {
	const url = `/admin/traeger/users/invite`;
	return axios
		.post(url, data)
		.then((x) => x.data)
		.then((x) => {
			if (x.status == 'error') {
				return Promise.reject(x);
			}
			return x;
		});
}

function resetUser(data) {
	const url = `/admin/traeger/users/reset`;
	return axios
		.post(url, data)
		.then((x) => x.data)
		.then((x) => {
			if (x.status == 'error') {
				return Promise.reject(x);
			}
			return x;
		});
}

function deactivateUser(data) {
	const url = `/admin/traeger/users/deactivate`;
	return axios
		.post(url, data)
		.then((x) => x.data)
		.then((x) => {
			if (x.status == 'error') {
				return Promise.reject(x);
			}
			return x;
		});
}

function setUserAccess(data) {
	const url = `/admin/traeger/users/access-set`;
	return axios
		.post(url, data)
		.then((x) => x.data)
		.then((x) => {
			if (x.status == 'error') {
				return Promise.reject(x);
			}
			return x;
		});
}

export {
	getAll,
	getTraeger,
	createTraeger,
	updateTraeger,
	getAvailableLocations,
	assignLocation,
	unassignLocation,
	inviteUser,
	resetUser,
	deactivateUser,
	setUserAccess,
};
